import {
  CardNamespace
} from "./chunk-YRD5K5ZZ.mjs";
import {
  ElementError
} from "./chunk-BVWBJ3I4.mjs";
import {
  ArrowUp,
  X,
  vars
} from "./chunk-P56JC6TB.mjs";
import {
  Popper,
  PopperContent,
  PopperTrigger,
  Ut
} from "./chunk-J7M6NLCU.mjs";
import {
  Button
} from "./chunk-BF5QNCEA.mjs";
import {
  assignInlineVars
} from "./chunk-2YDJLCMM.mjs";
import {
  Spinner
} from "./chunk-JYYKO2MH.mjs";
import {
  require_classnames
} from "./chunk-PXJBVWC7.mjs";
import {
  __async,
  __objRest,
  __spreadProps,
  __spreadValues,
  __toESM
} from "./chunk-WI73T6NA.mjs";

// ../../node_modules/@ebay/nice-modal-react/lib/esm/index.js
import React, { useEffect, useCallback, useContext, useReducer } from "react";
var __assign = function() {
  __assign = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = function(s, e) {
  var t = {};
  for (var p in s)
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t[p[i]] = s[p[i]];
    }
  return t;
};
var symModalId = Symbol("NiceModalId");
var initialState = {};
var NiceModalContext = React.createContext(initialState);
var NiceModalIdContext = React.createContext(null);
var MODAL_REGISTRY = {};
var ALREADY_MOUNTED = {};
var uidSeed = 0;
var dispatch = function() {
  throw new Error("No dispatch method detected, did you embed your app with NiceModal.Provider?");
};
var getUid = function() {
  return "_nice_modal_" + uidSeed++;
};
var reducer = function(state, action) {
  var _a, _b, _c;
  if (state === void 0) {
    state = initialState;
  }
  switch (action.type) {
    case "nice-modal/show": {
      var _d = action.payload, modalId = _d.modalId, args = _d.args;
      return __assign(__assign({}, state), (_a = {}, _a[modalId] = __assign(__assign({}, state[modalId]), {
        id: modalId,
        args,
        // If modal is not mounted, mount it first then make it visible.
        // There is logic inside HOC wrapper to make it visible after its first mount.
        // This mechanism ensures the entering transition.
        visible: !!ALREADY_MOUNTED[modalId],
        delayVisible: !ALREADY_MOUNTED[modalId]
      }), _a));
    }
    case "nice-modal/hide": {
      var modalId = action.payload.modalId;
      if (!state[modalId])
        return state;
      return __assign(__assign({}, state), (_b = {}, _b[modalId] = __assign(__assign({}, state[modalId]), { visible: false }), _b));
    }
    case "nice-modal/remove": {
      var modalId = action.payload.modalId;
      var newState = __assign({}, state);
      delete newState[modalId];
      return newState;
    }
    case "nice-modal/set-flags": {
      var _e = action.payload, modalId = _e.modalId, flags = _e.flags;
      return __assign(__assign({}, state), (_c = {}, _c[modalId] = __assign(__assign({}, state[modalId]), flags), _c));
    }
    default:
      return state;
  }
};
function showModal(modalId, args) {
  return {
    type: "nice-modal/show",
    payload: {
      modalId,
      args
    }
  };
}
function setModalFlags(modalId, flags) {
  return {
    type: "nice-modal/set-flags",
    payload: {
      modalId,
      flags
    }
  };
}
function hideModal(modalId) {
  return {
    type: "nice-modal/hide",
    payload: {
      modalId
    }
  };
}
function removeModal(modalId) {
  return {
    type: "nice-modal/remove",
    payload: {
      modalId
    }
  };
}
var modalCallbacks = {};
var hideModalCallbacks = {};
var getModalId = function(modal) {
  if (typeof modal === "string")
    return modal;
  if (!modal[symModalId]) {
    modal[symModalId] = getUid();
  }
  return modal[symModalId];
};
function show(modal, args) {
  var modalId = getModalId(modal);
  if (typeof modal !== "string" && !MODAL_REGISTRY[modalId]) {
    register(modalId, modal);
  }
  dispatch(showModal(modalId, args));
  if (!modalCallbacks[modalId]) {
    var theResolve_1;
    var theReject_1;
    var promise = new Promise(function(resolve, reject) {
      theResolve_1 = resolve;
      theReject_1 = reject;
    });
    modalCallbacks[modalId] = {
      resolve: theResolve_1,
      reject: theReject_1,
      promise
    };
  }
  return modalCallbacks[modalId].promise;
}
function hide(modal) {
  var modalId = getModalId(modal);
  dispatch(hideModal(modalId));
  delete modalCallbacks[modalId];
  if (!hideModalCallbacks[modalId]) {
    var theResolve_2;
    var theReject_2;
    var promise = new Promise(function(resolve, reject) {
      theResolve_2 = resolve;
      theReject_2 = reject;
    });
    hideModalCallbacks[modalId] = {
      resolve: theResolve_2,
      reject: theReject_2,
      promise
    };
  }
  return hideModalCallbacks[modalId].promise;
}
var remove = function(modalId) {
  dispatch(removeModal(modalId));
  delete modalCallbacks[modalId];
  delete hideModalCallbacks[modalId];
};
var setFlags = function(modalId, flags) {
  dispatch(setModalFlags(modalId, flags));
};
function useModal(modal, args) {
  var modals = useContext(NiceModalContext);
  var contextModalId = useContext(NiceModalIdContext);
  var modalId = null;
  var isUseComponent = modal && typeof modal !== "string";
  if (!modal) {
    modalId = contextModalId;
  } else {
    modalId = getModalId(modal);
  }
  if (!modalId)
    throw new Error("No modal id found in NiceModal.useModal.");
  var mid = modalId;
  useEffect(function() {
    if (isUseComponent && !MODAL_REGISTRY[mid]) {
      register(mid, modal, args);
    }
  }, [isUseComponent, mid, modal, args]);
  var modalInfo = modals[mid];
  var showCallback = useCallback(function(args2) {
    return show(mid, args2);
  }, [mid]);
  var hideCallback = useCallback(function() {
    return hide(mid);
  }, [mid]);
  var removeCallback = useCallback(function() {
    return remove(mid);
  }, [mid]);
  var resolveCallback = useCallback(function(args2) {
    var _a;
    (_a = modalCallbacks[mid]) === null || _a === void 0 ? void 0 : _a.resolve(args2);
    delete modalCallbacks[mid];
  }, [mid]);
  var rejectCallback = useCallback(function(args2) {
    var _a;
    (_a = modalCallbacks[mid]) === null || _a === void 0 ? void 0 : _a.reject(args2);
    delete modalCallbacks[mid];
  }, [mid]);
  var resolveHide = useCallback(function(args2) {
    var _a;
    (_a = hideModalCallbacks[mid]) === null || _a === void 0 ? void 0 : _a.resolve(args2);
    delete hideModalCallbacks[mid];
  }, [mid]);
  return {
    id: mid,
    args: modalInfo === null || modalInfo === void 0 ? void 0 : modalInfo.args,
    visible: !!(modalInfo === null || modalInfo === void 0 ? void 0 : modalInfo.visible),
    keepMounted: !!(modalInfo === null || modalInfo === void 0 ? void 0 : modalInfo.keepMounted),
    show: showCallback,
    hide: hideCallback,
    remove: removeCallback,
    resolve: resolveCallback,
    reject: rejectCallback,
    resolveHide
  };
}
var create = function(Comp) {
  return function(_a) {
    var _b;
    var defaultVisible = _a.defaultVisible, keepMounted = _a.keepMounted, id = _a.id, props = __rest(_a, ["defaultVisible", "keepMounted", "id"]);
    var _c = useModal(id), args = _c.args, show2 = _c.show;
    var modals = useContext(NiceModalContext);
    var shouldMount = !!modals[id];
    useEffect(function() {
      if (defaultVisible) {
        show2();
      }
      ALREADY_MOUNTED[id] = true;
      return function() {
        delete ALREADY_MOUNTED[id];
      };
    }, [id, show2, defaultVisible]);
    useEffect(function() {
      if (keepMounted)
        setFlags(id, { keepMounted: true });
    }, [id, keepMounted]);
    var delayVisible = (_b = modals[id]) === null || _b === void 0 ? void 0 : _b.delayVisible;
    useEffect(function() {
      if (delayVisible) {
        show2(args);
      }
    }, [delayVisible, args, show2]);
    if (!shouldMount)
      return null;
    return React.createElement(
      NiceModalIdContext.Provider,
      { value: id },
      React.createElement(Comp, __assign({}, props, args))
    );
  };
};
var register = function(id, comp, props) {
  if (!MODAL_REGISTRY[id]) {
    MODAL_REGISTRY[id] = { comp, props };
  } else {
    MODAL_REGISTRY[id].props = props;
  }
};
var NiceModalPlaceholder = function() {
  var modals = useContext(NiceModalContext);
  var visibleModalIds = Object.keys(modals).filter(function(id) {
    return !!modals[id];
  });
  visibleModalIds.forEach(function(id) {
    if (!MODAL_REGISTRY[id] && !ALREADY_MOUNTED[id]) {
      console.warn("No modal found for id: " + id + ". Please check the id or if it is registered or declared via JSX.");
      return;
    }
  });
  var toRender = visibleModalIds.filter(function(id) {
    return MODAL_REGISTRY[id];
  }).map(function(id) {
    return __assign({ id }, MODAL_REGISTRY[id]);
  });
  return React.createElement(React.Fragment, null, toRender.map(function(t) {
    return React.createElement(t.comp, __assign({ key: t.id, id: t.id }, t.props));
  }));
};
var InnerContextProvider = function(_a) {
  var children = _a.children;
  var arr = useReducer(reducer, initialState);
  var modals = arr[0];
  dispatch = arr[1];
  return React.createElement(
    NiceModalContext.Provider,
    { value: modals },
    children,
    React.createElement(NiceModalPlaceholder, null)
  );
};
var Provider = function(_a) {
  var children = _a.children, givenDispatch = _a.dispatch, givenModals = _a.modals;
  if (!givenDispatch || !givenModals) {
    return React.createElement(InnerContextProvider, null, children);
  }
  dispatch = givenDispatch;
  return React.createElement(
    NiceModalContext.Provider,
    { value: givenModals },
    children,
    React.createElement(NiceModalPlaceholder, null)
  );
};

// src/dialog/manager.tsx
var import_classnames = __toESM(require_classnames());
import { useState } from "react";

// src/dialog/dialog.css.ts
var dialogBody = "dialog_dialogBody__b3lce96";
var dialogContentCard = "dialog_dialogContentCard__b3lce93";
var dialogContentHeader = "dialog_dialogContentHeader__b3lce97";
var dialogContentHeaderButton = "dialog_dialogContentHeaderButton__b3lce98";
var dialogFooter = "dialog_dialogFooter__b3lce94";
var dialogManagerSubmitBtn = "dialog_dialogManagerSubmitBtn__b3lce95";

// src/dialog/manager.tsx
import { Fragment, jsx, jsxs } from "@emotion/react/jsx-runtime";
var DialogManager = create((props) => {
  const {
    id,
    className,
    children,
    cancelBtn,
    confirmBtn,
    afterClickConfirm,
    payload,
    hideOnConfirm,
    hideControls,
    dialogContentCss,
    cardStyle
  } = props;
  const [loading, setLoading] = useState(false);
  const modal = useModal(id);
  const setOpen = (p) => {
    if (p) {
      modal.show();
    } else {
      modal.remove();
    }
  };
  const classes = (0, import_classnames.default)("pq-dialog__manager", className);
  const onClickHandler = (e) => __async(void 0, null, function* () {
    setLoading(true);
    try {
      if (afterClickConfirm)
        yield afterClickConfirm(e, payload, { modal });
      if (payload)
        modal.resolve(payload);
      if (hideOnConfirm)
        modal.remove();
    } catch (error) {
      modal.reject(error);
    }
    setLoading(false);
  });
  const renderCancelBtn = () => {
    const _a = cancelBtn != null ? cancelBtn : {}, { hide: hide2, title, onCancel } = _a, cancelBtnRest = __objRest(_a, ["hide", "title", "onCancel"]);
    if (hide2 || !cancelBtn)
      return null;
    return /* @__PURE__ */ jsx(
      Button,
      __spreadProps(__spreadValues({
        variant: "secondary-blue",
        onClick: (e) => __async(void 0, null, function* () {
          if (onCancel) {
            yield onCancel(e);
          }
          modal.remove();
        }),
        title
      }, cancelBtnRest), {
        children: title
      })
    );
  };
  const renderSubmitBtn = () => {
    const _a = confirmBtn != null ? confirmBtn : {}, {
      hide: hide2,
      title,
      onConfirm,
      disabled,
      className: btnClassName
    } = _a, confirmBtnRest = __objRest(_a, [
      "hide",
      "title",
      "onConfirm",
      "disabled",
      "className"
    ]);
    if (hide2)
      return null;
    const btnClasses = (0, import_classnames.default)(btnClassName, dialogManagerSubmitBtn);
    return /* @__PURE__ */ jsxs(
      Button,
      __spreadProps(__spreadValues({
        variant: "primary-blue",
        className: btnClasses,
        onClick: (e) => __async(void 0, null, function* () {
          if (onConfirm) {
            yield onConfirm(e);
          }
          yield onClickHandler(e);
        }),
        disabled: loading || disabled,
        title
      }, confirmBtnRest), {
        children: [
          title,
          loading && /* @__PURE__ */ jsx(
            Spinner,
            {
              color: "#ffffff",
              style: { marginLeft: "1em" },
              height: 11,
              width: 11
            }
          )
        ]
      })
    );
  };
  const renderControls = () => {
    if (hideControls)
      return null;
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      renderCancelBtn(),
      renderSubmitBtn()
    ] });
  };
  return /* @__PURE__ */ jsx(
    DialogNamespace,
    {
      isOpen: modal.visible,
      onOpenChange: setOpen,
      open: modal.visible,
      className: classes,
      children: /* @__PURE__ */ jsxs(DialogNamespace.Content, { cardStyle, css: dialogContentCss, children: [
        children,
        /* @__PURE__ */ jsx(DialogNamespace.Footer, { children: renderControls() })
      ] })
    }
  );
});

// src/dialog/dialog.tsx
var import_classnames5 = __toESM(require_classnames());
import { forwardRef as forwardRef6 } from "react";

// src/dialog/heading.tsx
var import_classnames2 = __toESM(require_classnames());
import { createElement, forwardRef, useId, useLayoutEffect } from "react";
var DialogHeading = forwardRef(
  (props, ref) => {
    const _a = props, { className, as, children } = _a, rest = __objRest(_a, ["className", "as", "children"]);
    const { setLabelId } = Ut();
    const id = useId();
    useLayoutEffect(() => {
      setLabelId(id);
      return () => setLabelId(void 0);
    }, [id, setLabelId]);
    const classes = (0, import_classnames2.default)("pq-dialog__heading", className);
    return createElement(
      as,
      __spreadProps(__spreadValues({
        className: classes
      }, rest), {
        id,
        ref
      }),
      children
    );
  }
);
DialogHeading.displayName = "DialogHeading";

// src/dialog/body.tsx
var import_classnames3 = __toESM(require_classnames());
import { forwardRef as forwardRef2, useId as useId2, useLayoutEffect as useLayoutEffect2 } from "react";
import { jsx as jsx2 } from "@emotion/react/jsx-runtime";
var DialogBody = forwardRef2(
  (props, ref) => {
    const _a = props, { className, children } = _a, rest = __objRest(_a, ["className", "children"]);
    const { setDescriptionId } = Ut();
    const id = useId2();
    useLayoutEffect2(() => {
      setDescriptionId(id);
      return () => setDescriptionId(void 0);
    }, [id, setDescriptionId]);
    const classes = (0, import_classnames3.default)("pq-dialog__body", className, dialogBody);
    return /* @__PURE__ */ jsx2("div", __spreadProps(__spreadValues({ className: classes }, rest), { id, ref, children }));
  }
);
DialogBody.displayName = "DialogBody";

// src/dialog/content.tsx
import { forwardRef as forwardRef3 } from "react";

// src/uploader/image/index.css.ts
var container = "image_container__17uo4lh0";
var cursorStyle = "var(--cursorStyle__17uo4lh2)";
var descriptionStyle = "image_descriptionStyle__17uo4lh8";
var errorStyle = "image_errorStyle__17uo4lhd";
var iconStyle = "image_iconStyle__17uo4lhb";
var imageContainer = "image_imageContainer__17uo4lh3";
var imageContainerOutline = "var(--imageContainerOutline__17uo4lh1)";
var infoStyle = "image_infoStyle__17uo4lhc";
var innerContainer = "image_innerContainer__17uo4lh6";
var innerContainerBorderColor = "var(--innerContainerBorderColor__17uo4lh5)";
var inputStyle = "image_inputStyle__17uo4lh9";
var titleStyle = "image_titleStyle__17uo4lh7";

// src/uploader/image/stock-svg.tsx
import { jsx as jsx3, jsxs as jsxs2 } from "@emotion/react/jsx-runtime";
var StockSvg = (props) => /* @__PURE__ */ jsxs2("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24 }, props), { children: [
  /* @__PURE__ */ jsx3("title", { children: "BE9EE876-18BD-4A77-A47A-84E5D2E43D0A" }),
  /* @__PURE__ */ jsxs2("g", { fill: "none", fillRule: "evenodd", children: [
    /* @__PURE__ */ jsx3("path", { d: "M0 0h24v24H0z" }),
    /* @__PURE__ */ jsx3(
      "path",
      {
        fill: "#1A3154",
        fillRule: "nonzero",
        d: "M21 6h-3.17L16 4h-5a1 1 0 0 0 0 2h4.12l1.83 2H21v12H5v-8a1 1 0 0 0-2 0v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2Z"
      }
    ),
    /* @__PURE__ */ jsx3(
      "path",
      {
        fill: "#1A3154",
        fillRule: "nonzero",
        d: "M13 9c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5Zm0 2c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3-1.35-3-3-3Z"
      }
    ),
    /* @__PURE__ */ jsx3(
      "path",
      {
        fill: "#FF696D",
        fillRule: "nonzero",
        d: "M5 6h2a1 1 0 1 0 0-2H5V2a1 1 0 1 0-2 0v2H1a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0V6Z"
      }
    )
  ] })
] }));
var stock_svg_default = StockSvg;

// src/uploader/image/close.tsx
import { jsx as jsx4, jsxs as jsxs3 } from "@emotion/react/jsx-runtime";
var CloseComponent = (props) => /* @__PURE__ */ jsxs3(
  "svg",
  __spreadProps(__spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), {
    children: [
      /* @__PURE__ */ jsx4("rect", { width: 18, height: 18, x: 1, y: 1, fill: "#3F6DB4", rx: 9 }),
      /* @__PURE__ */ jsx4(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M14.72 6.628 11.35 10l3.37 3.373a.954.954 0 0 1-1.348 1.349L10 11.349 6.628 14.72a.954.954 0 0 1-1.349-1.35L8.651 10 5.28 6.63a.954.954 0 1 1 1.35-1.35L10 8.651l3.37-3.372a.954.954 0 0 1 1.35 1.35Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx4(
        "rect",
        {
          width: 18,
          height: 18,
          x: 1,
          y: 1,
          stroke: "#fff",
          strokeWidth: 2,
          rx: 9
        }
      )
    ]
  })
);
var close_default = CloseComponent;

// src/uploader/image/image.tsx
import { isValidElement, useState as useState2 } from "react";
import { jsx as jsx5, jsxs as jsxs4 } from "@emotion/react/jsx-runtime";
var ImageUploader = (props) => {
  const _a = props, {
    error,
    acceptedMimeTypes = ["image/png", "image/jpeg", "image/svg"],
    image,
    btnLabel,
    title,
    description,
    inputProps,
    onImageRemove
  } = _a, rest = __objRest(_a, [
    "error",
    "acceptedMimeTypes",
    "image",
    "btnLabel",
    "title",
    "description",
    "inputProps",
    "onImageRemove"
  ]);
  const [hover, setHover] = useState2(false);
  const parseMimeTypes = acceptedMimeTypes.join(",");
  const renderImage = () => {
    if (typeof image === "string") {
      return /* @__PURE__ */ jsx5(stock_svg_default, {});
    } else if (isValidElement(image)) {
      return image;
    }
    return image;
  };
  const hasError = () => {
    if (typeof error === "string") {
      return !!error;
    }
    return !!(error == null ? void 0 : error.message);
  };
  const renderError = () => {
    if (!error)
      return null;
    if (typeof error === "string") {
      return /* @__PURE__ */ jsx5("span", { className: errorStyle, children: error });
    }
    return /* @__PURE__ */ jsx5(ElementError, { errors: error, name: inputProps == null ? void 0 : inputProps.name, showErrorBoard: true });
  };
  const setCusorStyle = () => {
    if (inputProps == null ? void 0 : inputProps.disabled)
      return "not-allowed";
    if (!image)
      return "auto";
    return "pointer";
  };
  const setImageContainerOutline = () => {
    if (!image || (inputProps == null ? void 0 : inputProps.disabled))
      return "1px rgba(203,208,223,0.3)";
    return `2px ${vars.color.blue["40"]}`;
  };
  const imageContainerStyle = assignInlineVars({
    [imageContainerOutline]: setImageContainerOutline(),
    [cursorStyle]: setCusorStyle()
  });
  return /* @__PURE__ */ jsxs4("div", __spreadProps(__spreadValues({ className: container }, rest), { children: [
    /* @__PURE__ */ jsxs4(
      "div",
      {
        className: innerContainer,
        style: assignInlineVars({
          [innerContainerBorderColor]: hasError() ? "rgba(255,105,109,0.5)" : "rgba(203, 208, 223, 0.3)"
        }),
        children: [
          /* @__PURE__ */ jsxs4(
            "div",
            {
              className: imageContainer,
              style: imageContainerStyle,
              onMouseEnter: () => setHover(true),
              onMouseLeave: () => setHover(false),
              children: [
                hover && image && !(inputProps == null ? void 0 : inputProps.disabled) && /* @__PURE__ */ jsx5(
                  close_default,
                  {
                    style: {
                      position: "absolute",
                      top: -10,
                      right: -10
                    },
                    onClick: onImageRemove
                  }
                ),
                renderImage()
              ]
            }
          ),
          /* @__PURE__ */ jsxs4("div", { className: infoStyle, children: [
            /* @__PURE__ */ jsxs4("div", { children: [
              /* @__PURE__ */ jsx5("p", { className: titleStyle, children: title }),
              /* @__PURE__ */ jsx5("p", { className: descriptionStyle, children: description })
            ] }),
            /* @__PURE__ */ jsxs4(
              Button,
              {
                size: "md",
                variant: "secondary-blue",
                disabled: inputProps == null ? void 0 : inputProps.disabled,
                children: [
                  /* @__PURE__ */ jsx5(ArrowUp, { className: iconStyle, size: 18 }),
                  /* @__PURE__ */ jsx5("span", { children: btnLabel }),
                  /* @__PURE__ */ jsx5(
                    "input",
                    __spreadValues({
                      className: inputStyle,
                      type: "file",
                      name: "file",
                      accept: parseMimeTypes
                    }, inputProps)
                  )
                ]
              }
            )
          ] })
        ]
      }
    ),
    renderError()
  ] }));
};

// src/dialog/content.tsx
import { jsx as jsx6, jsxs as jsxs5 } from "@emotion/react/jsx-runtime";
var DialogContent = forwardRef3(
  (props, forwardedRef) => {
    const _a = props, { cardStyle } = _a, popperContentProps = __objRest(_a, ["cardStyle"]);
    const { setOpen } = Ut();
    const renderPopperWithCard = () => {
      return /* @__PURE__ */ jsx6(
        PopperContent,
        __spreadProps(__spreadValues({
          useOverlay: true,
          useModal: true
        }, popperContentProps), {
          ref: forwardedRef,
          children: /* @__PURE__ */ jsxs5(CardNamespace, { className: dialogContentCard, style: cardStyle, children: [
            /* @__PURE__ */ jsx6(CardNamespace.Header, { children: /* @__PURE__ */ jsx6("div", { className: dialogContentHeader, children: /* @__PURE__ */ jsx6(
              Button,
              {
                role: "button",
                className: dialogContentHeaderButton,
                onKeyDown: (e) => {
                  switch (e.key) {
                    case "Escape":
                      setOpen(false);
                      break;
                  }
                },
                onClick: () => {
                  setOpen(false);
                },
                style: {
                  position: "absolute"
                },
                variant: "default",
                children: /* @__PURE__ */ jsx6(X, { color: vars.color.gray["30"] })
              }
            ) }) }),
            /* @__PURE__ */ jsx6(CardNamespace.Content, { children: props.children })
          ] })
        })
      );
    };
    return renderPopperWithCard();
  }
);
DialogContent.displayName = "DialogContent";

// src/dialog/trigger.tsx
var import_classnames4 = __toESM(require_classnames());
import { forwardRef as forwardRef4 } from "react";
import { jsx as jsx7 } from "@emotion/react/jsx-runtime";
var DialogTrigger = forwardRef4((props, propRef) => {
  const _a = props, { children, className } = _a, restProps = __objRest(_a, ["children", "className"]);
  const classes = (0, import_classnames4.default)("pq-dialog__trigger", className);
  return /* @__PURE__ */ jsx7(PopperTrigger, __spreadProps(__spreadValues({ className: classes, ref: propRef }, restProps), { children }));
});
DialogTrigger.displayName = "DialogTrigger";

// src/dialog/footer.tsx
import { forwardRef as forwardRef5 } from "react";
import { jsx as jsx8 } from "@emotion/react/jsx-runtime";
var DialogFooter = forwardRef5(
  (props, ref) => {
    const { children } = props;
    return /* @__PURE__ */ jsx8("div", { className: dialogFooter, ref, children });
  }
);
DialogFooter.displayName = "DialogFooter";

// src/dialog/dialog.tsx
import { jsx as jsx9 } from "@emotion/react/jsx-runtime";
var Dialog = forwardRef6(
  (props, forwardedRef) => {
    const _a = props, { children, className } = _a, options = __objRest(_a, ["children", "className"]);
    const classes = (0, import_classnames5.default)("pq-dialog", className);
    return /* @__PURE__ */ jsx9(Popper, __spreadProps(__spreadValues({ role: "dialog" }, options), { children: /* @__PURE__ */ jsx9("div", { ref: forwardedRef, className: classes, children }) }));
  }
);
Dialog.displayName = "Dialog";
var DialogNamespace = Object.assign(Dialog, {
  Trigger: DialogTrigger,
  Heading: DialogHeading,
  Body: DialogBody,
  Content: DialogContent,
  Footer: DialogFooter
});

export {
  show,
  remove,
  useModal,
  create,
  register,
  Provider,
  DialogManager,
  DialogNamespace,
  ImageUploader
};
//# sourceMappingURL=chunk-AAWUPBVJ.mjs.map